import { createApi } from '@reduxjs/toolkit/query/react'
import RtkBaseQueryWithReauth from './RtkBaseQueryWithReauth'
import ApiPath from './ConstantApi'
import { HelpDataModel, HelpQuestions } from '../Helpers/Interfaces/HelpType';


export interface PaymentGatewayResponse {
  _id?: string;
  name: string;
  provider: string;
  stripe_key?: string;
  isActive: boolean;
  stripe_secret?: string;
  createdAt: Date;
  adyen_api_key?: string;
  adyen_client_key?: string;
  adyen_merchant_account?: string;
  adyen_hmac_key?: string;
}
export interface PaymentGatewayData {
  _id?: string;
  name: string;
  provider: string;
  stripe_key?: string;
  isActive: boolean;
  stripe_secret?: string;
  createdAt?: Date;
  adyen_api_key?: string;
  adyen_client_key?: string;
  adyen_merchant_account?: string;
  adyen_hmac_key?: string;
}

export interface PaymentGatewayRequest {
  id: string;
  data: PaymentGatewayData;
}


export const HelpService = createApi({
  reducerPath: 'HelpService',
  baseQuery: RtkBaseQueryWithReauth(process.env.REACT_APP_BASE_URL || ''),
  tagTypes: ['Help'],
  endpoints: (builder) => ({
    getHelpList: builder.query({
      query: () => ({
        url: ApiPath.helpService,
        method: 'GET'
      }),
      transformResponse: (response: { data: HelpDataModel }) => response.data,
      providesTags: ['Help']
    }),

    updateHelp: builder.mutation({
      query: ({ _id, data }: any) => ({
        url: `${ApiPath.helpServiceUpdate}/${_id}`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ['Help']
    }),

    addHelp: builder.mutation({
      query: (data) => ({
        url: `${ApiPath.helpServiceSave}`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['Help']
    }),

    deleteHelp: builder.mutation({
      query: (helpId) => ({
        url: `${ApiPath.helpServiceDelete}/${helpId}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Help']
    }),

    getCustomerHelpList: builder.mutation<any, any>({
      query: (payload) => ({
        url: ApiPath.customerhelp,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Help'],
    }),

    updateTicketStatus: builder.mutation<any, { _id: string; status: string }>({
      query: (payload) => ({
        url: `${ApiPath.updateticketbyid}/${payload._id}`,
        method: 'PUT',
        body: { status: payload.status },
      }),
      invalidatesTags: ["Help"],
    }),

    getPaymentGatewayList: builder.query({
      query: () => ({
        url: ApiPath.getpaymentgateway,
        method: 'GET'
      }),
      transformResponse: (response: { data: any }) => response.data,
      providesTags: ['Help']
    }),

    addAndUpdatePaymentGateway: builder.mutation<PaymentGatewayResponse, PaymentGatewayData>({
      query: (payload) => ({
        url: ApiPath.paymentgatewayAdd, // single endpoint
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ["Help"],
    }),


    addAndUpdateNotification: builder.mutation<any, any>({
      query: (payload) => {
        if ('_id' in payload) {
          return {
            url: `${ApiPath.updateNotification}/${payload._id}`,
            method: 'PUT',
            body: payload.data,
          };
        }
        return {
          url: ApiPath.addNotification,
          method: 'POST',
          body: payload.data,
        };
      },
      invalidatesTags: ["Help"],
    }),


    getNotification: builder.query<any, any>({
      query: (params) => ({
        url: `${ApiPath.getNotification}?page=${params.page}&pageSize=${params.pageSize}`,
        method: "GET",
      }),
      providesTags: ["Help",],
    }),
  }),


})
export const {
  useGetHelpListQuery,
  useUpdateHelpMutation,
  useAddHelpMutation,
  useDeleteHelpMutation,
  useGetCustomerHelpListMutation,
  useUpdateTicketStatusMutation,
  useGetPaymentGatewayListQuery,
  useAddAndUpdatePaymentGatewayMutation,
  useGetNotificationQuery,
  useAddAndUpdateNotificationMutation
} = HelpService
